import Vue from 'vue'
import gmapsInit from '../utils/gmaps'/* eslint-disable-line */

Vue.prototype.$gmapsInit = gmapsInit
